import { render, staticRenderFns } from "./lnk-crm-iframe.vue?vue&type=template&id=03e4c633&scoped=true&"
import script from "./lnk-crm-iframe.vue?vue&type=script&lang=js&"
export * from "./lnk-crm-iframe.vue?vue&type=script&lang=js&"
import style0 from "./lnk-crm-iframe.vue?vue&type=style&index=0&id=03e4c633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e4c633",
  null
  
)

export default component.exports